import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { push } from "connected-react-router";

import Modal from "../../ui/Modals/ModalWindow";
import MessageForm from "../../ui/MessageForm/MessageForm";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";

import { createMessageAsync, clearMessageForm } from "../../../redux/actions/editMessage";
import { openCancelModal, closeCancelModal } from "../../../redux/actions/ui";

const mapStateToProps = state => ({
  ...state.editMessage,
  cancelModal: state.ui.cancelModal,
});

const mapDispatchToProps = dispatch => ({
  openCancelModal: () => dispatch(openCancelModal()),
  closeCancelModal: () => dispatch(closeCancelModal()),
  onGoBack: () => dispatch(push('/messages')),
  onCreateMessage: () => dispatch(createMessageAsync()),
  clearForm: () => dispatch(clearMessageForm()),
});

class CreateMessage extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    message: PropTypes.object.isRequired,
    onGoBack: PropTypes.func.isRequired,
    cancelModal: PropTypes.object.isRequired,
    openCancelModal: PropTypes.func.isRequired,
    closeCancelModal: PropTypes.func.isRequired,
    onCreateMessage: PropTypes.func.isRequired,
    clearForm: PropTypes.func.isRequired,
  };

  formIsEmpty = () => {
    const { message } = this.props;
    if (
      (message.title.length === 0) //Название не меняли
      && (message.message.length === 0) //Текст сообщения не меняли
      && (!message.clients && !message.consultants) //Оба чекбокса не меняли
      && (message.type === 'release') //Тип не меняли
    ) return true; 
    return false;
  }

  askOrGoBack = () => {
    const { message, openCancelModal, onGoBack } = this.props;
    this.formIsEmpty(message) ? onGoBack() : openCancelModal();
  }

  closeModalAndGo = () => {
    const { closeCancelModal, onGoBack, clearForm } = this.props;
    closeCancelModal();
    clearForm();
    onGoBack();
  }

  render() {
    const { ready, loading, message, cancelModal, closeCancelModal, onCreateMessage } = this.props;

    return (
      <div className="page-wrapper">
        <Modal
          confirmText="Остаться"
          cancelText="Покинуть страницу"
          modal={cancelModal}
          onSubmit={() => closeCancelModal()}
          onCancel={() => this.closeModalAndGo()}
        />
        <div className="page-header">
          {ready ? (
            <button type="button" className="btn btn-back" onClick={() => this.askOrGoBack()}>
              <i aria-hidden="true" className="back-icon icon" />
              <span>Назад</span> 
            </button>
          ) : false}
        </div>
        <div className="page-content forms">
          <div className="form-header">Создание сообщения</div>
          {ready ? (
            <MessageForm
              message={message}
              submitText="Создать сообщение"
              onSubmit={() => onCreateMessage()}
            />
          ) : false}
          {loading ? (<Spinner />) : false}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(CreateMessage));
